// import { AxiosError } from 'axios';

import { toast } from 'react-toastify';
import { uniqueId } from 'lodash';
import api from '../../api';

export async function getNotificationsByUserAndCompanyIdRequest(
  userId: string,
  companyId: string,
  size: string,
  page: string,
) {
  try {
    const response = await api().get(`/notifications/user/${userId}`, {
      headers: {
        companyId,
      },
      params: {
        size,
        page,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function updateNotificationToRead(
  id: string,
  userId: string,
  companyId: string,
) {
  try {
    const response = api().patch(
      `/notifications/read/${id}`,
      {},
      {
        headers: {
          companyId,
          userId,
        },
      },
    );

    return response;
  } catch (err: any) {
    console.log(err);
    if (err.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(err.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}

export async function removeNotification(
  id: string,
  userId: string,
  companyId: string,
) {
  try {
    const response = api().patch(
      `/notifications/remove/${id}`,
      {},
      {
        headers: {
          companyId,
          userId,
        },
      },
    );

    return response;
  } catch (err: any) {
    console.log(err);
    if (err.response.status === 500) {
      toast.error('Erro desconhecido, contate o suporte', {
        toastId: uniqueId(),
      });
    } else {
      toast.error(err.response.data.message, {
        toastId: uniqueId(),
      });
    }
    return null;
  }
}
